const toVisibleAlertsArray = alertsMap => Array.from(alertsMap.values());

export const makeAlertsManager = (setAlerts, plugin) => {
  const alertsMap = new Map();
  let id = 0;

  const add = (alert, alertRef) => {
    var _alertRef$current$id, _alertRef$current;

    const alertId = (_alertRef$current$id = (_alertRef$current = alertRef.current) === null || _alertRef$current === void 0 ? void 0 : _alertRef$current.id) !== null && _alertRef$current$id !== void 0 ? _alertRef$current$id : ++id;
    const alertsMapAlert = { ...alert,
      id: alertId,
      remove: () => {
        alertsMap.delete(alertId);
        alertRef.current = null;
        setAlerts(toVisibleAlertsArray(alertsMap));
      }
    };
    alertsMap.set(alertId, alertsMapAlert);
    setAlerts(toVisibleAlertsArray(alertsMap));
    return alertsMapAlert;
  };

  return {
    add,
    plugin
  };
};